import {
  EventName,
  FullyQualifiedMessageName,
  HawkEvent,
  WidgetInteractedData,
} from '../entry/sendEvent';

import { BaseEvent } from './BaseEvent';

export class WidgetInteracted extends BaseEvent {
  hawkEvent: HawkEvent;

  constructor({ area, action, widget }: Pick<WidgetInteractedData, 'area' | 'action' | 'widget'>) {
    super();
    this.hawkEvent = {
      name: EventName.WIDGET_INTERACTED,
      fullyQualifiedMessageName: FullyQualifiedMessageName.WIDGET_INTERACTED,
      data: {
        fieWidgetsVersion: this.fieWidgetsVersion,
        context: {
          page: this.page,
          content: this.content,
          site: this.site,
          experiment: this.experiment,
          user: this.user,
        },
        interactedAt: new Date().toISOString(),
        area,
        action,
        widget,
      },
    };
  }
}
